import { retrieveChatCredentials } from './firebase.js'

export const fetchChatCredentials = async () => {
  return await retrieveChatCredentials()
}
